import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ImportFile } from './blacklist';

@Injectable()
export class BlacklistService {
  constructor(private http: HttpClient) {}

  blacklist(params) {
    if (params.msisdnLike) {
      params.msisdnLike = params.msisdnLike.replace('+', '');
    }
    return this.http.get('/dnclist', { params });
  }

  info(msisdn) {
    return this.http.get(`/dnclist/${msisdn}`);
  }

  addNumbersToBlackList(numbersList) {
    return this.http.post('/dnclist/block', numbersList);
  }

  removeNumbersToBlackList(numbersList) {
    return this.http.post('/dnclist/unblock', numbersList);
  }

  importFileToBlacklist(importFile: ImportFile) {
    return this.http.post('/dnclist/import', importFile.fileForm, {
      params: {
        operation: importFile.action
      }
    });
  }
}
